import { Box, Text } from "@dehub/theme";
import { LockSimpleIcon } from "@phosphor-icons/react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import classes from "../PartnerPage.module.css";

export type DefinitionItem = {
  key: string;
  label: string;
  value: ReactNode;
  locked?: boolean;
  wide?: boolean;
};

type Props = Readonly<{
  items: DefinitionItem[];
}>;

const isEmpty = (value: ReactNode) => value === null || value === undefined || value === "";

export function DefinitionList({ items }: Props) {
  const { t } = useTranslation("partner");

  return (
    <Box component="dl" className={classes.defList}>
      {items.map((item) => (
        <Box key={item.key} className={`${classes.defRow} ${item.wide ? classes.defRowWide : ""}`}>
          <Box component="dt" className={classes.defLabel}>
            {item.label}
            {item.locked ? (
              <LockSimpleIcon
                className={classes.lockIcon}
                size={14}
                weight="bold"
                role="img"
                aria-label={t("lockedHint")}
              />
            ) : null}
          </Box>
          <Box component="dd" className={classes.defValue}>
            {isEmpty(item.value) ? (
              <Text span className={classes.empty}>
                -
              </Text>
            ) : (
              item.value
            )}
          </Box>
        </Box>
      ))}
    </Box>
  );
}
